import {mapActions, mapState} from 'vuex'
import {renewReply} from '@api/renewal'
import {replyReferral} from '@api/refer'
import ReplyNewSmeRefer from '@/views/tickets/components/sme/reply-new-sme-refer'
export default {
  data() {
    return {
      company_id:'',
      plan_name:''
    }
  },
  computed: {
    isSME(){
      return this.productId>=80
    },
    quote_name(){
      let name = ''
      this.newSMEOptions.insurer.some(item=>{
        if(item.id==this.company_id)
          name = item.name
      })
      return `${name||''} ${this.plan_name||''}`
    },

  },
  watch:{
  },
  methods: {
  }
}
